import React, { createContext, PropsWithChildren, useContext, useEffect, useState } from "react";
import { GetEngineProviderBrandConfigurationByDomainRequest } from "../gen/witbooking/backoffice/engineproviderbrandconfiguration/v1/engineproviderbrandconfiguration_api_pb";
import { ACCESS_DENIED } from "../lib/auth";
import { useKeycloakAuthz } from "./keycloak-provider";

export type LogoType = "LARGE" | "LARGE_WHITE" | "FAVICON";
export type LinkType = "SUPPORT_CENTER" | "KNOWLEDGE_DATABASE";

// FIXME: enums generated by protoc DO NOT have reverse mapping
export enum GEmailType {
  INVALID = 0,
  NO_REPLY = 1,
  CONTACT_EMAIL = 2,
}

export enum GExternalSiteType {
  INVALID_EXTERNAL_SITE_TYPE = 0,
  SUPPORT_CENTER = 1,
  KNOWLEDGE_DATABASE = 2,
}

export enum GLogoType {
  INVALID_LOGO_TYPE = 0,
  LARGE = 1,
  LARGE_WHITE = 2,
  FAVICON = 3,
}

export interface IMultimedia {
  id: string;
  filename: string;
  url: string;
}

export interface IWhiteLabelLogos {
  multimedia: IMultimedia;
  logoType: LogoType;
}

export interface IWhiteLabelLink {
  url: string;
  externalSiteType: LinkType;
}

export interface IEmailConfiguration {
  emailAddress: string;
  emailType: "NO_REPLY" | "CONTACT_EMAIL";
}

export interface IWhiteLabelCompany {
  name: string;
  phone: string;
}

export interface IPropertyWhiteLabel {
  palette: any;
  logoConfigurations: IWhiteLabelLogos[];
  externalSiteConfigurations: IWhiteLabelLink[];
  emailConfigurations: IEmailConfiguration[];
  company: IWhiteLabelCompany;
}

type WhiteLabelValue = IPropertyWhiteLabel | undefined | null;
const WhiteLabel = createContext<WhiteLabelValue>(undefined);

export function WhiteLabelProvider({ children }: PropsWithChildren<{}>) {
  const [data, setData] = useState<WhiteLabelValue>(undefined);
  const keycloakAuthz = useKeycloakAuthz();

  useEffect(() => {
    async function load() {
      try {
        const request = new GetEngineProviderBrandConfigurationByDomainRequest();
        // FIXME: workaround for localhost since the backend does not recognize localhost
        // as a valid domain name
        const domain =
          window.location.hostname === "localhost" ||
          window.location.hostname.includes("devel.witbooking.com")
            ? "admin.devel.witbooking.com"
            : window.location.hostname;
        request.setDomain(domain);
        //const response = await grpcClient.getEngineProviderBrandConfigurationByDomain(request);
        // const engineProviderBrandConfiguration: EngineProviderBrandConfiguration.AsObject = response
        //   .getEngineproviderbrandconfiguration()!!
        //   .toObject();
        // const gPalette: Palette.AsObject = engineProviderBrandConfiguration.palette!!;

        // const whiteLabelValue: WhiteLabelValue = {
        //   company: {
        //     name: engineProviderBrandConfiguration.company!!.name,
        //     phone: engineProviderBrandConfiguration.company!!.phone,
        //   },
        //   emailConfigurations: engineProviderBrandConfiguration.emailconfigurationsList.map(it => ({
        //     emailAddress: it.emailaddress,
        //     emailType: GEmailType[it.emailtype] as IEmailConfiguration["emailType"],
        //   })),
        //   externalSiteConfigurations: engineProviderBrandConfiguration.externalsiteconfigurationsList.map(
        //     it => ({
        //       url: it.url,
        //       externalSiteType: GExternalSiteType[
        //         it.externalsitetype
        //       ] as IWhiteLabelLink["externalSiteType"],
        //     })
        //   ),
        //   logoConfigurations: engineProviderBrandConfiguration.logoconfigurationsList.map(it => ({
        //     multimedia: {
        //       id: it.multimedia!!.id,
        //       filename: it.multimedia!!.filename,
        //       url: it.multimedia!!.url,
        //     },
        //     logoType: GLogoType[it.logotype] as IWhiteLabelLogos["logoType"],
        //   })),
        //   palette: {
        //     primary: {
        //       light: gPalette.primary!!.light,
        //       main: gPalette.primary!!.main,
        //       dark: gPalette.primary!!.dark,
        //       contrastText: gPalette.primary!!.contrasttext,
        //     },
        //     secondary: {
        //       light: gPalette.secondary!!.light,
        //       main: gPalette.secondary!!.main,
        //       dark: gPalette.secondary!!.dark,
        //       contrastText: gPalette.secondary!!.contrasttext,
        //     },
        //     error: {
        //       light: gPalette.error!!.light,
        //       main: gPalette.error!!.main,
        //       dark: gPalette.error!!.dark,
        //       contrastText: gPalette.error!!.contrasttext,
        //     },
        //     success: {
        //       light: gPalette.success!!.light,
        //       main: gPalette.success!!.main,
        //       dark: gPalette.success!!.dark,
        //       contrastText: gPalette.success!!.contrasttext,
        //     },
        //   },
        // };
        const whiteLabelValue: WhiteLabelValue = {
          company: { name: "Witbooking", phone: "123456" },
          emailConfigurations: [
            { emailAddress: "info@witbooking.com", emailType: "CONTACT_EMAIL" },
            { emailAddress: "no-reply@witbooking.com", emailType: "NO_REPLY" },
          ],
          externalSiteConfigurations: [
            {
              url: "https://witbooking.freshdesk.com/es/support/solutions",
              externalSiteType: "SUPPORT_CENTER",
            },
            {
              url: "https://witbooking.freshdesk.com/es/support/solutions",
              externalSiteType: "KNOWLEDGE_DATABASE",
            },
          ],
          logoConfigurations: [
            {
              multimedia: {
                id: "3a4e76b2-7b5d-43af-98d5-b6ef9b72fc3b",
                filename: "logo_login.png",
                url:
                  "https://engine-provider-brand.s3.eu-west-1.amazonaws.com/witbooking/logo_login.png",
              },
              logoType: "LARGE",
            },
            {
              multimedia: {
                id: "edb82ba3-1584-4085-9e05-0ea57264d30a",
                filename: "logo_header.png",
                url:
                  "https://engine-provider-brand.s3.eu-west-1.amazonaws.com/witbooking/logo_header.png",
              },
              logoType: "LARGE_WHITE",
            },
            {
              multimedia: {
                id: "e3f39918-3a38-4d27-a0c3-7fc44c56084c",
                filename: "favicon.ico",
                url:
                  "https://s3.eu-central-1.amazonaws.com/witbooking.static/img/favicon-septeo.ico",
              },
              logoType: "FAVICON",
            },
          ],
          palette: {
            id: "76083468-bba0-4dca-92c7-c89d0d6dccd2",
            ticker: "palette",
            paletteType: "PUBLIC",
            primary: {
              light: "#FFB09B",
              main: "#FF6136",
              dark: "#f64516",
              contrastText: "#FFFFFF",
            },
            secondary: {
              light: "#636fc1",
              main: "#2E3862",
              dark: "rgba(0, 33, 13, 1)",
              contrastText: "#FFFFFF",
            },
            error: {
              light: "rgba(229, 115, 115, 1)",
              main: "rgba(244, 67, 54, 1)",
              dark: "rgba(211, 47, 47, 1)",
              contrastText: "rgba(255, 255, 255, 1)",
            },
            success: {
              light: "rgba(96, 255, 163, 1)",
              main: "rgba(0, 207, 115, 1)",
              dark: "rgba(0, 156, 70, 1)",
              contrastText: "rgba(255, 255, 255, 1)",
            },
          },
        };
        setData(whiteLabelValue);
      } catch (e) {
        if (e === ACCESS_DENIED) {
          console.error("Access denied", e);
        } else {
          console.error("Error retrieving rpt", e);
        }
      }
    }

    load();
  }, [keycloakAuthz]);

  return <WhiteLabel.Provider value={data}>{children}</WhiteLabel.Provider>;
}

export function useWhiteLabel(): WhiteLabelValue {
  return useContext(WhiteLabel);
}
